import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Food from "../../../images/services/cto/Food.svg";
import BankingFinance from "../../../images/services/cto/banking-finance.svg";
import Education from "../../../images/services/cto/Education.svg";
import Healthcare from "../../../images/services/cto/Healthcare.svg";
import LegalServices from "../../../images/services/cto/legal-services.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Techsolution(props) {
    return (
        <div className="p-100 tekrevol_gray_bg">
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={7} xxl={7}>
                        <div className="example" data-text="HR Solutions">
                            <h2>Custom LMS Development For Diverse Industries</h2>
                        </div>
                    </Col>
                </Row>
                <Row className="tech_bg">
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tech_tabs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Healthcare}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Healthcare
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>TekRevol has contributed impact-oriented development to the healthcare sector by
                                        building custom software programs, SaaS solutions, and mobile and web apps for
                                        medical hospitals, wellness organizations, and telemedicine service providers.
                                        An industry-specific LMS can help these organizations invest training efforts in
                                        nurses, practitioners, primary care doctors, and other administrative staff to
                                        improve the patient experience.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={BankingFinance}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Banking and Finance
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Financial services is a highly consumer-centric industry, and an LMS that
                                        continually polishes the hard and soft skills of client-facing human resources
                                        can significantly improve leads and conversion rates. Tekrevol can help
                                        insurance, Fintech, banks, and asset management companies take their
                                        organizational learning and development efforts to the next level.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Food}
                                        effect="blur" alt="Food" className="img-fluid"
                                    />
                                    Food and hospitality
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Considering the strict compliance systems in the hospitality industry, food
                                        businesses and hotels can train their staff to provide better customer and guest
                                        experiences at online and offline outlets.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={Education}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Education
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The education industry has skyrocketed with learning management system
                                        development because of remote access to learning resources, progress tracking
                                        and assessment systems, improved student engagement, and automated educator with
                                        student communication.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4">
                                <Accordion.Header>
                                    <LazyLoadImage
                                        src={LegalServices}
                                        effect="blur" alt="Healthcare" className="img-fluid"
                                    />
                                    Legal services
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Law firms can take their legal practice to the next level with an online learning
                                        management system. It can track conferences, trial results, mock trials, and the
                                        progress of new lawyers and provide convenient remote access to learning
                                        resources.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Techsolution;